import { WithClassname } from '../../types';
import { Alert, Button } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { IPromoCode } from '../../types/coupon';
import ClickToCopy from '../helpers/ClickToCopy';
import React from 'react';
import usePromoCode from '../../hooks/coupon/usePromoCode';
import useHelpers from '../../hooks/utility/useHelpers';
import { getPromoCodes } from '../../services/api/CouponService';
import useStore from '../../hooks/context/useStore';
import useOngoingOrder from '../../hooks/context/useOngoingOrder';
import collect from 'collect.js';

type Props = {
  onPromoCodeApply: (code: string) => void;
} & WithClassname;

export default function PublicPromoCode({ onPromoCodeApply, className }: Props) {
  const { storeId } = useStore();
  const { orderData } = useOngoingOrder();
  const { formatCurrency } = useHelpers();
  const { getCurrentComponent, formatDiscount } = usePromoCode();

  const [promoCode, setPromoCode] = useState<IPromoCode>(null);

  useEffect(() => {
    loadPromoCodes();
  }, []);

  async function loadPromoCodes() {
    if (!storeId || !orderData.customer.phone_number) {
      return;
    }

    getPromoCodes(storeId, { user_phone_number: orderData.customer.phone_number })
      .then(({ data }) => setPromoCode(collect(data).first()))
      .catch((error) => console.error('Failed to load promo codes', { error }));
  }

  const currentComponent = useMemo(
    () => (promoCode ? getCurrentComponent(promoCode) : null),
    [promoCode],
  );

  const formattedDiscount = useMemo(
    () => (currentComponent ? formatDiscount(currentComponent, promoCode.discount_type) : null),
    [currentComponent],
  );

  return (
    Boolean(promoCode) && (
      <Alert
        message={
          <p>
            Promo code:{' '}
            <ClickToCopy value={promoCode.code} reverted>
              <b>{promoCode.code}</b>
            </ClickToCopy>
          </p>
        }
        description={
          <>
            <ul className="list-disc list-inside">
              {Boolean(formattedDiscount) && <li>{formattedDiscount} Discount</li>}
              {Boolean(currentComponent?.usage_threshold) && (
                <li>{formatCurrency(currentComponent.usage_threshold)} min basket value</li>
              )}
            </ul>
            <Button onClick={() => onPromoCodeApply(promoCode.code)} className="w-full mt-sm">
              Apply
            </Button>
          </>
        }
        className={className}
      />
    )
  );
}
